var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.ref,staticClass:"j-lottie-wrap"})
}
var staticRenderFns = []

export { render, staticRenderFns }